<template>
  <div>
    <div>
      <md-icon>thumb_up</md-icon>
      <!-- <md-tooltip md-direction="top">Curtidas</md-tooltip> -->
      {{ reactions? reactions.count[1] : "-" }}
      <md-icon>comment</md-icon>
      <!-- <md-tooltip md-direction="top">Comentários</md-tooltip> -->
      {{ comments? comments.length : "-" }}
      <md-icon>visibility</md-icon>
      <!-- <md-tooltip md-direction="top">Visualizações</md-tooltip> -->
      {{ chapter? chapter.views : "-" }}
    </div>

    <div class="group-comment-send">
      <prompt-login>
        <md-button
          :class="{ 'md-raised': !currentReaction, 'md-dense': currentReaction }"
          class="md-primary buttonAction"
          slot-scope="{ showAlert }"
          :disabled="reactionSubmit == 'loading'"
          :md-ripple="false"
          @click="user? reactToChapter(1) : showAlert()"
        >
          <md-icon>thumb_up</md-icon>
          <md-tooltip md-direction="top">{{ currentReaction? "Curtido" : "Curtir"}}</md-tooltip>
        </md-button>
      </prompt-login>

      <prompt-login>
        <md-button
          class="md-raised md-primary buttonAction"
          slot-scope="{ showAlert }"
          :md-ripple="false"
          @click="user? focusTextField() : showAlert()"
        >
          <md-icon>comment</md-icon>
          <md-tooltip md-direction="top">Comentar</md-tooltip>
        </md-button>
      </prompt-login>

      <md-button
        class="md-raised md-primary buttonAction"
        :md-ripple="false"
        @click="shareDialog = true"
      >
        <md-icon>share</md-icon>
        <md-tooltip md-direction="top">Compartilhar</md-tooltip>
      </md-button>
    </div>

    <comments
      v-if="comments != null"
      class="comments"
      :comments="comments"
      :profiles="commentProfiles"
      :editSubmit="editStatus"
      @edit="editComment"
      @delete="promptRemove"
      @resetEdit="editStatus = false"
    />

    <div v-if="user || !$route.params.isProduction">
      <md-field>
        <label ref="fieldComment" class="commentChapter">Comentário</label>
        <!-- <md-textarea v-model="currentComment" class="md-scrollbar" md-autogrow maxlength="1000"></md-textarea> -->
        <md-textarea v-model="newComment" maxlength="1000"></md-textarea>
      </md-field>

      <md-button :disabled="newComment == '' || commentSubmit != false && commentSubmit != 'error'" :md-ripple="false" type="submit" class="md-raised md-primary buttonSend" @click="sendNewComment(newComment)">
        <span v-show="commentSubmit == false">
          Enviar
          <md-icon class="md-primary iconSend">send</md-icon>
        </span>
        <div v-show="commentSubmit == 'loading'" class="loader"/>
        <span v-show="commentSubmit == 'error'">Erro!</span>
        <span v-show="commentSubmit == true">Enviado!</span>
      </md-button>
    </div>

    <md-dialog :md-active.sync="deleteDialog">
      <md-dialog-title>Você tem certeza que deseja deletar seu comentário?</md-dialog-title>
      <md-dialog-actions>
        <md-button @click="removeComment()" :disabled="deleteStatus != false">
          <span v-if="!deleteStatus">Sim!</span>
          <loader v-else-if="deleteStatus == 'loading'" />
          <span v-else-if="deleteStatus == 'error'">Erro!</span>
          <span v-else>Deletado!</span>
        </md-button>
        <md-button style="background: lightgrey;" @click="deleteDialog = false">
          Cancelar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <share-dialog
      :share="shareDialog"
      :title="chapter.title"
      :content="chapter.content"
      @close="shareDialog = $event"
    />
  </div>
</template>

<script>
import LogRocket from "logrocket";
import promptLogin from "@/components/shared/promptLogin";
import shareDialog from "@/components/shared/shareDialog";
import loader from "@/components/shared/loader";
import comments from "./comments";
import call from "@/api/calls";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: "chapterReactions",
  components: {
    promptLogin,
    shareDialog,
    comments,
    loader
  },
  props: ['chap'],
  mounted() {
    this.loadComments();
    this.loadReactions();
  },
  methods: {
    focusTextField: function() {
      this.commentSubmit = false;
      this.$refs.fieldComment.focus();
    },
    loadReactions() {
      return call.reaction.get(this.$route.params.id)
      .then(reactns => {
        if (this.user && this.user.id)
          this.currentReaction = reactns.reactions.find(r => r.userId === this.user.id)
        return this.reactions = reactns;
      })
    },
    reactToChapter(reaction) {
      // if not this.reactions then do nothing
      if (!this.reactions)  return;
      if (this.user.id) {
        this.reactionSubmit = 'loading';
        call.reaction.react(this.$route.params.id, this.user.id, reaction)
        .then(result => {
          this.reactionSubmit = true;
          this.currentReaction = result;
          this.reactions.count[reaction] += result? 1 : -1;
        })
        .catch(error => {
          this.reactionSubmit = 'error';
          log(error, "reactToChapter(reaction)", { reaction });
          this.error = error;
        });
      }
    },
    loadComments() {
      return call.comment.getByChapter(this.$route.params.id)
      .then(comments => {
        this.comments = comments;
        return call.profile.getChaptersData(comments.map(c => c['authorId']));
      })
      .then(profiles => this.commentProfiles = profiles)
      .catch(error => {
        log(error, "loadComments()", null);
        return this.error=error;
      });
    },
    sendNewComment(content) {
      this.commentSubmit = 'loading';
      return call.comment.create({
        chapterId: this.$route.params.id,
        authorId: this.user.id,
        content
      })
      .then(comment => {
        this.commentSubmit = true;
        this.newComment = '';

        if (Array.isArray(this.comments))
          this.comments.push(comment);
        else this.comments = [comment];

        if (Array.isArray(this.commentProfiles))
          this.commentProfiles.push(this.user);
        else this.commentProfiles = [this.user];
      })
      .catch(error => {
        this.commentSubmit = 'error';
        log(error, "sendNewComment(content)", null);
        this.error = error;
      })
    },
    editComment(commentId, content) {
      this.editStatus = "loading";
      if (this.comments.find(c => c.commentId === commentId).content == content) {
        return this.editStatus = true;
      }
      call.comment.edit(this.chapter.id, commentId, content)
      .then(comment => {
        if (comment[0] == 1) {
          this.editStatus = true;
          this.comments.find(c => c.commentId === commentId).content = content;
        }
      })
      .catch(error => {
        this.deleteStatus="error";
        log(error, "loadComments()", { commentId });
        this.error = error;
      });
    },
    promptRemove(commentId) {
      this.currentComment = commentId;
      this.deleteDialog = true;
      this.deleteStatus = false;
    },
    removeComment() {
      this.deleteStatus = "loading";
      call.comment.remove(this.chapter.id, this.currentComment, this.user && this.user.id)
      .then(result => {
        if (result) {
          this.deleteStatus = true;
          this.comments.splice(this.comments.findIndex(comment => comment.commentId == result.commentId), 1);
        }
        else {
          this.deleteStatus = "error";
        }
        this.deleteDialog = false;
      })
      .catch(error => {
        this.deleteStatus = "error";
        log(error, "removeComment()", { chapterId: this.chapter.id, commentId: this.currentComment });
        this.error = error;
      })
    }
  },
  data() {
    return {
      shareDialog: false,
      deleteDialog: false,
      deleteStatus: false,
      editStatus: false,
      currentComment: null,
      newComment: '',
      currentReaction: null,
      reactionSubmit: false,
      reactions: null,
      commentSubmit: false,
      comments: null,
      commentProfiles: null,
      chapter: this.chap || this.$route.params.chapter,
      error: null
    };
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
  }
};
</script>

<style scoped>
.buttonAction {
  position: relative;
  display: block;
  float: left;
  width: fit-content;
  margin-top: 4%;
  border-radius: 50px;
}

.comments {
  display: inline-block;
  margin: auto;
  width: 100%;
}

.group-comment-send {
  padding: 15px 0;
}

.buttonSend {
  left: 0;
  width: 8em;
  border-radius: 50px;
}

.iconSend {
  margin-left: 10%;
}

@media (max-width: 823px) {
  ::-webkit-scrollbar-track {
    opacity: 0;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #c6e7e1;
  }
  ::-webkit-scrollbar-thumb {
    background: #11999e;
  }

  .buttonAction {
    width: 100%;
    margin: 0 auto 0.6em auto;
  }
}

@media (max-width: 768px) {
  ::-webkit-scrollbar-track {
    opacity: 0;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #c6e7e1;
  }
  ::-webkit-scrollbar-thumb {
    background: #11999e;
  }

  .buttonAction {
    width: 100%;
    margin: 0.3em auto;
  }
}

@media (max-width: 414px) {
  ::-webkit-scrollbar-track {
    opacity: 0;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #c6e7e1;
  }
  ::-webkit-scrollbar-thumb {
    background: #11999e;
  }

  .buttonAction {
    width: 100%;
    margin: 0.3em auto;
  }
}

</style>
